import { of, from } from 'rxjs';
import { map, first, catchError } from 'rxjs/operators';
import axios from 'axios';
import { isDebugLogging } from 'env/env';

const DEFAULT_FAILURE_MESSAGE = { response: 'failure', message: '' };

const utilMapper = (resultData, msg) => {
   if (msg === 'KEYWORD_SEARCH') {
      const combinedData = { data: [] };
      resultData.learned.forEach((item) => {
         const learnedItem = { type: 'Learned', ...item };
         combinedData.data.push(learnedItem);
      });
      resultData.unlearned.forEach((item) => {
         const unLearnedItem = { type: 'Unlearned', ...item };
         combinedData.data.push(unLearnedItem);
      });

      return combinedData;
   }

   return resultData;
};

export const cleanRequestData = (data) => {
   return Object.entries(data).reduce((a, [k, v]) => (v === undefined ? a : (a[k] = v, a)), {});
};


export const serverPostRequestByUrlAndDataWithMsg = (url, requestData, msg = '') => {
   const cleanedRequestData = cleanRequestData(requestData);
   return from(
      axios.post(
         url,
         cleanedRequestData,
         {
            headers: {
               'Content-Type': 'application/json',
            },
         },
      ),
   ).pipe(
      first(),
      map((res) => {
         return (res && res.data ? utilMapper(res.data, msg) : {});
      }),
      catchError((err) => {
         if (isDebugLogging()) {
            console.log(err);
         }
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: msg });
      }),
   );
};


export const serverGetRequestByUrl = (url, msg = '') => {
   return from(
      axios.get(
         url,
         {
            headers: {
               'Content-Type': 'application/json',
            },
         },
      ),
   ).pipe(
      first(),
      map((res) => {
         return (res && res.data ? utilMapper(res.data, msg) : {});
      }),
      catchError((err) => {
         if (isDebugLogging()) {
            console.log(err);
         }
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: msg });
      }),
   );
};


export const serverPatchRequestByUrlAndDataWithMsg = (url, requestData, msg = '') => {
   const cleanedRequestData = cleanRequestData(requestData);
   return from(
      axios.patch(
         url,
         cleanedRequestData,
         {
            headers: {
               'Content-Type': 'application/json',
            },
         },
      ),
   ).pipe(
      first(),
      map((res) => {
         return (res && res.data ? utilMapper(res.data, msg) : {});
      }),
      catchError((err) => {
         if (isDebugLogging()) {
            console.log(err);
         }
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: msg });
      }),
   );
};

export const serverPostRequestByUrlAndDataWithMsgMultipart = (url, requestData, msg = '') => {
   return from(
      axios.post(
         url,
         requestData,
         {
            headers: {
               'Content-Type': undefined,
            },
         },
      ),
   ).pipe(
      first(),
      map((res) => {
         return (res && res.data ? utilMapper(res.data, msg) : {});
      }),
      catchError((err) => {
         if (isDebugLogging()) {
            console.log(err);
         }
         return of({ ...DEFAULT_FAILURE_MESSAGE, message: msg });
      }),
   );
};


export const serverPostRequestByUrlAndDataWithMsgForExport = (downloadUrl, requestData, msg = '', filename = 'Report.csv') => {
   const cleanedRequestData = cleanRequestData(requestData);

   return axios.post(
      downloadUrl,
      cleanedRequestData,
      {
         headers: {
            'Content-Type': 'application/json',
         },
         responseType: 'blob',
      },
   ).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
   });
};

export const serverPostRequest = (apiURL) => {
   return (payload = {}) => {
      const sanitizedPayload = cleanRequestData(payload);
      return axios.post(
         apiURL,
         sanitizedPayload,
      );
   };
};

export const stubResponse = (stubData) => {
   const stubPromise = new Promise((resolve) => {
      setTimeout(() => {
         resolve(stubData);
      }, 300);
   });

   return from(stubPromise);

   //    .pipe(
   //    first(),
   //    map((res) => {
   //       console.log('res', res);
   //       return (res && res.data ? utilMapper(res.data, '') : {});
   //    }),
   //    catchError((err) => {
   //       if (isDebugLogging()) {
   //          console.log(err);
   //       }
   //       return of({ ...DEFAULT_FAILURE_MESSAGE, message: '' });
   //    }),
   // );
};
